const Forms = [
  {
    type: "multipleSelect",
    options: "CatStatus",
    label: "status",
    class: "col-md-4 col-lg-4 col-sm-12",
    name: "Status",
    id: "Status",
    id2: "Status",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatConsignor",
    label: "receive_consignor",
    class: "col-md-4 col-lg-4 col-sm-12",
    name: "Consignor",
    id2: "Consignor",
    id: "Consignor",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatConsignee",
    label: "receive_consignee",
    id2: "Consignee",
    class: "col-md-4 col-lg-4 col-sm-12",
    name: "Consignee",
    id: "Consignee",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatObservation",
    label: "receive_observation",
    id2: "Observation",
    class: "col-md-6 col-lg-5 col-sm-12",
    name: "Observation",
    id: "Observation",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },

  {
    type: "Datetime",
    label: "dispatch_received",
    name: "ReceivedList",
    class: "col-md-12 col-lg-3 col-sm-12",
    id: "ReceivedList",
    id2: "ReceivedList",
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    format: "YYYY-MM-DD",
    values: [],
  },
  {
    type: "Datetime",
    label: "dispatch_released",
    name: "ReleasedList",
    class: "col-md-12 col-lg-3 col-sm-12",
    id: "ReleasedList",
    id2: "ReleasedList",
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    format: "YYYY-MM-DD",
    values: [],
  },
];

export default Forms;
